import type { editor } from 'monaco-editor';

export const LEETSHADERS_DARK_THEME = 'leetshaders-dark';
export const LEETSHADERS_LIGHT_THEME = 'leetshaders-light';

export const leetshadersDarkTheme: editor.IStandaloneThemeData = {
  base: 'vs-dark',
  inherit: false,
  rules: [
    { token: '', foreground: 'e6edf3', background: '0d1117' },
    { token: 'comment', foreground: '484f58', fontStyle: 'italic' },
    { token: 'keyword', foreground: 'ff7b72' },
    { token: 'type', foreground: '79c0ff' },
    { token: 'identifier', foreground: 'e6edf3' },
    { token: 'number', foreground: 'ffa657' },
    { token: 'number.float', foreground: 'ffa657' },
    { token: 'function', foreground: 'd2a8ff' },
    { token: 'variable', foreground: 'ffa657' },
    { token: 'operator', foreground: '8b949e' },
    { token: 'delimiter', foreground: '8b949e' },
    { token: 'delimiter.bracket', foreground: '8b949e' },
    { token: 'preprocessor', foreground: 'ff7b72' },
  ],
  colors: {
    'editor.background': '#0d1117',
    'editor.foreground': '#e6edf3',
    'editor.lineHighlightBackground': '#161b2240',
    'editor.selectionBackground': '#58a6ff25',
    'editor.inactiveSelectionBackground': '#58a6ff12',
    'editorCursor.foreground': '#58a6ff',
    'editorLineNumber.foreground': '#30363d',
    'editorLineNumber.activeForeground': '#8b949e',
    'editorIndentGuide.background': '#21262d',
    'editorIndentGuide.activeBackground': '#30363d',
    'editorBracketMatch.background': '#58a6ff15',
    'editorBracketMatch.border': '#58a6ff40',
    'scrollbarSlider.background': '#21262d80',
    'scrollbarSlider.hoverBackground': '#30363d80',
    'scrollbarSlider.activeBackground': '#30363d',
    'editorWidget.background': '#161b22',
    'editorWidget.border': '#21262d',
    'editorGutter.background': '#0d1117',
  },
};

export const leetshadersLightTheme: editor.IStandaloneThemeData = {
  base: 'vs',
  inherit: false,
  rules: [
    { token: '', foreground: '1f2328', background: 'ffffff' },
    { token: 'comment', foreground: '6e7781', fontStyle: 'italic' },
    { token: 'keyword', foreground: 'cf222e' },
    { token: 'type', foreground: '0550ae' },
    { token: 'identifier', foreground: '1f2328' },
    { token: 'number', foreground: '953800' },
    { token: 'number.float', foreground: '953800' },
    { token: 'function', foreground: '8250df' },
    { token: 'variable', foreground: '953800' },
    { token: 'operator', foreground: '57606a' },
    { token: 'delimiter', foreground: '57606a' },
    { token: 'delimiter.bracket', foreground: '57606a' },
    { token: 'preprocessor', foreground: 'cf222e' },
  ],
  colors: {
    'editor.background': '#ffffff',
    'editor.foreground': '#1f2328',
    'editor.lineHighlightBackground': '#f6f8fa',
    'editor.selectionBackground': '#0969da25',
    'editor.inactiveSelectionBackground': '#0969da12',
    'editorCursor.foreground': '#0969da',
    'editorLineNumber.foreground': '#8c959f',
    'editorLineNumber.activeForeground': '#1f2328',
    'editorIndentGuide.background': '#d0d7de',
    'editorIndentGuide.activeBackground': '#8c959f',
    'editorBracketMatch.background': '#0969da15',
    'editorBracketMatch.border': '#0969da40',
    'scrollbarSlider.background': '#8c959f30',
    'scrollbarSlider.hoverBackground': '#8c959f50',
    'scrollbarSlider.activeBackground': '#8c959f70',
    'editorWidget.background': '#f6f8fa',
    'editorWidget.border': '#d0d7de',
    'editorGutter.background': '#ffffff',
  },
};
